<template>
  <div class="bottomfooter">
    <div class="top">
      <img src="../assets/image/bottom_1.png" alt="" style=""/>
      <img src="../assets/image/bottom_2.png" alt="" />
      <img src="../assets/image/bottom_3.png" alt="" style="width: 1.8rem" />
      <img src="../assets/image/bottom_5.png" alt="" style="width: 1.8rem;height: 1.8rem;" />
      <img src="../assets/image/bottom_6.png" alt="" style="width: 1.8rem" />
      <img src="../assets/image/bottom_4.png" alt="" style="width: 1.5rem" />
    </div>

    <a href="https://beian.miit.gov.cn" style="text-decoration: none;">
      <div class="bottom">
        <div class="xian"></div>
        <p>版权所有©2016浙江省宁波钱湖柏庭养老投资有限公司 浙ICP备15021973号-6</p>
      </div>
    </a>
  </div>
</template>
  <script>
export default {
  name: "bottomfooter",
  data() {
    return {};
  },
  methods: {},
  mounted: function () {},
  components: {},
};
</script>
  <style  scoped="scoped">
.bottomfooter {
  width: 100%;
  height: 3.6625rem;
  background: #40684b;
}
.top {
  padding: 0 3rem;
  height: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top>img:nth-child(1) {
  width: 2.1375rem;
  height: 0.6875rem;
}

.top>img:nth-child(2) {
 width: 1.5125rem;
height: 1.5875rem;
}
.top>img:nth-child(3) {
 width: 1.8625rem;
height: 0.8375rem;
}
.top>img:nth-child(4) {
  width: 1.675rem;
height: 1.675rem;
}
.bottom {
  width: 100%;
  height: calc(100% - 3rem);
}
.xian {
  height: 2px;
  background: #bbb389;
  opacity: 0.48;
}
.bottom p {
  height: calc(100% - 2px);
  font-size: 16px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #ffffff;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>